export const REQUIRED_FIELD_MESSAGE = 'This field is required';
